import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { MultiplyIcon } from '@koaly/koaly-ui-icons';
import { getFontTokenStyle, getSizeToken, getVariantToken, marginBottomSpacing, getColorToken } from '@koaly/mixins';
import React from 'react';
import styled from 'styled-components';

const StyledTag = styled.span `
  ${getFontTokenStyle('label', 'small', undefined, 'bold')};
  position: relative;
  white-space: nowrap;
  display: inline-block;
  border-radius: ${getSizeToken('tag', 'borderRadius')};
  background-color: ${getVariantToken('tag', 'backgroundColor')};
  color: ${getVariantToken('tag', 'color')};
  padding: ${({ buttonRight }) => buttonRight ?
    getSizeToken('tag', 'paddingWithIconButton') : getSizeToken('tag', 'padding')};
  ${({ spaceAfter }) => spaceAfter && marginBottomSpacing(spaceAfter)};
`;
const CloseButton = styled.button `
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  top: 0;
  padding: 5px;
  font-size: 12px;
  height: 100%;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  color: ${getVariantToken('tag', 'color')};
  border-bottom-right-radius: ${getSizeToken('tag', 'borderRadius')};
  border-top-right-radius: ${getSizeToken('tag', 'borderRadius')};

  &:hover, &:focus {
    background: ${getColorToken('650', 'danger')};
    color: ${getVariantToken('tag', 'color')};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px ${getVariantToken('tag', 'color')};;
  }
`;
const Tag = (_a) => {
    var { children, spaceAfter, onRemove } = _a, rest = __rest(_a, ["children", "spaceAfter", "onRemove"]);
    return (React.createElement(StyledTag, Object.assign({ spaceAfter: spaceAfter, buttonRight: !!onRemove }, rest),
        children,
        onRemove && React.createElement(CloseButton, { type: "button", "aria-label": "Remove", onClick: onRemove },
            React.createElement(MultiplyIcon, null))));
};
Tag.defaultProps = {};

export { Tag };
//# sourceMappingURL=Tag.js.map
